import { Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { LoadingBlock } from "./components/ui/LoadingBlock";
import { ContactPage } from "./pages/ContactPage";
import { DonatePage } from "./pages/DonatePage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ThankYouPage } from "./pages/ThankYouPage";

const AboutPage = lazy(() =>
  import("./pages/AboutPage").then((module) => ({ default: module.AboutPage })),
);
const CommunityPage = lazy(() =>
  import("./pages/CommunityPage").then((module) => ({ default: module.CommunityPage })),
);
const LearningHubPage = lazy(() =>
  import("./pages/LearningHubPage").then((module) => ({ default: module.LearningHubPage })),
);
const MediaPage = lazy(() =>
  import("./pages/MediaPage").then((module) => ({ default: module.MediaPage })),
);
const PrivacyPage = lazy(() =>
  import("./pages/PrivacyPage").then((module) => ({ default: module.PrivacyPage })),
);
const ProgramsPage = lazy(() =>
  import("./pages/ProgramsPage").then((module) => ({ default: module.ProgramsPage })),
);
const ProjectSupportPage = lazy(() =>
  import("./pages/ProjectSupportPage").then((module) => ({ default: module.ProjectSupportPage })),
);
const StoriesPage = lazy(() =>
  import("./pages/StoriesPage").then((module) => ({ default: module.StoriesPage })),
);
const TermsPage = lazy(() =>
  import("./pages/TermsPage").then((module) => ({ default: module.TermsPage })),
);
const DonationPolicyPage = lazy(() =>
  import("./pages/DonationPolicyPage").then((module) => ({ default: module.DonationPolicyPage })),
);

const RouteLoader = () => (
  <div className="mx-auto max-w-6xl px-6 py-20">
    <LoadingBlock title="Loading page" message="Preparing the next section of the site." />
  </div>
);

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
};

const App = () => (
  <AppShell>
    <ScrollToTop />
    <Suspense fallback={<RouteLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/learning-hub" element={<LearningHubPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/project-support" element={<ProjectSupportPage />} />
        <Route path="/stories" element={<StoriesPage />} />
        <Route path="/members-contributors-donors" element={<Navigate replace to="/community" />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/donation-policy" element={<DonationPolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  </AppShell>
);

export default App;
